import { resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_FocusLock = _resolveComponent("FocusLock")!
  const _component_Form = _resolveComponent("Form")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.visible) = $event)),
    width: "500"
  }, {
    activator: _withCtx(({ props: activatorProps }) => [
      _createVNode(_component_v_list_item, _mergeProps(activatorProps, { onClick: _ctx.open }), {
        default: _withCtx(() => [
          _createVNode(_component_v_list_item_title, {
            textContent: _toDisplayString(_ctx.$t('archiv.table.burgermenu.edit'))
          }, null, 8, ["textContent"])
        ]),
        _: 2
      }, 1040, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Form, null, {
        default: _withCtx(({ meta }) => [
          _createVNode(_component_FocusLock, null, {
            default: _withCtx(() => [
              _createElementVNode("form", {
                id: "focusLockDialogForm",
                onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
              }, [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "headline font-weight-bold mb-2" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('lieferant.einstellungen.edituserdialog.title')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, { class: "pb-0" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.benutzerCopy.loginId,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.benutzerCopy.loginId) = $event)),
                          label: _ctx.$t('einstellungen.addaccount.email') + '*',
                          placeholder: "example@test.com",
                          disabled: "",
                          readonly: ""
                        }, null, 8, ["modelValue", "label"]),
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.benutzerCopy.rollen,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.benutzerCopy.rollen) = $event)),
                          "item-props": _ctx.itemProps,
                          items: _ctx.LieferantBenutzerRollen,
                          label: _ctx.$t('einstellungen.addaccount.rolle'),
                          "menu-props": { attach: '#focusLockDialogForm' }
                        }, null, 8, ["modelValue", "item-props", "items", "label"]),
                        _createVNode(_component_Field, {
                          modelValue: _ctx.benutzerCopy.vorname,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.benutzerCopy.vorname) = $event)),
                          name: "Vorname",
                          rules: _ctx.getValidation('benutzerCreateApiDto.vorname')
                        }, {
                          default: _withCtx(({ errors, field }) => [
                            _createVNode(_component_v_text_field, _mergeProps(field, {
                              modelValue: _ctx.benutzerCopy.vorname,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.benutzerCopy.vorname) = $event)),
                              label: _ctx.$t('einstellungen.addaccount.vorname') + '*',
                              placeholder: "...",
                              "error-messages": errors
                            }), null, 16, ["modelValue", "label", "error-messages"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules"]),
                        _createVNode(_component_Field, {
                          modelValue: _ctx.benutzerCopy.nachname,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.benutzerCopy.nachname) = $event)),
                          name: "Nachname",
                          rules: _ctx.getValidation('benutzerCreateApiDto.nachname')
                        }, {
                          default: _withCtx(({ errors, field }) => [
                            _createVNode(_component_v_text_field, _mergeProps(field, {
                              modelValue: _ctx.benutzerCopy.nachname,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.benutzerCopy.nachname) = $event)),
                              label: _ctx.$t('einstellungen.addaccount.nachname') + '*',
                              placeholder: "...",
                              "error-messages": errors
                            }), null, 16, ["modelValue", "label", "error-messages"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules"]),
                        _createVNode(_component_Field, {
                          modelValue: _ctx.benutzerCopy.mobilNummer,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.benutzerCopy.mobilNummer) = $event)),
                          name: "MobilNummer",
                          rules: _ctx.getValidation('benutzerCreateApiDto.mobilNummer') + '|valid_swiss_telephone_number'
                        }, {
                          default: _withCtx(({ errors, field }) => [
                            _createVNode(_component_v_text_field, _mergeProps(field, {
                              modelValue: _ctx.benutzerCopy.mobilNummer,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.benutzerCopy.mobilNummer) = $event)),
                              label: _ctx.$t('einstellungen.addaccount.mobilnummer') + '*',
                              placeholder: "+41 77 111 22 33",
                              "error-messages": errors
                            }), null, 16, ["modelValue", "label", "error-messages"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, { class: "ml-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          disabled: !meta.valid || _ctx.requiredFieldsFilled,
                          variant: "flat",
                          class: "modalbutton mb-3",
                          onClick: _ctx.onSave
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('components.dialog.save')), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"]),
                        _createVNode(_component_v_btn, {
                          class: "modalbutton mb-3",
                          variant: "flat",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.visible = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('components.dialog.cancel')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ], 32)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}